<template>
  <el-col :span="24" :style="{height: height}" style="position: absolute;" class="customHotMap">
    <div id="baiduMap" style="height: 100%;width:100%;" />
    <div class="leftMenu" :style="{width:getLeftItemWidth()}" v-if="showClassify">
      <div style="width: 100%;margin-top: 10px;cursor: pointer;" v-for="(item,index) in chartConfig.classifyConfig" :style="getSelectStyle(item)">
        <div class="item" @click="changeClassify(item)" :style="{height:getLeftItemHeight(),lineHeight:getLeftItemHeight(),marginLeft:getLeftMargin()}">
          <img :src="item.icon" alt="" :style="{width:getLeftItemImageWidth()}" style="margin-right: 10px;" />
          {{item.name}}
        </div>
      </div>
    </div>
    <div class="input-card" style="width: 220px;overflow-y: auto;" v-if="showRoadCard">
      <div v-for="(item,index) in roadData">
        <button class="btn" :style="{backgroundColor:getBtnColor(item)}" style="color: #FFFFFF;border: #FFFFFF;">
        {{item.desc}}</button>
        </div>
    </div>
    <HotMapMarkerDialog ref="markerDialog" :currentMarker="currentMarker"></HotMapMarkerDialog>
     <ImageOpenDialog ref="imageMarkerDialog" :currentMarker="currentMarker"></ImageOpenDialog>
  </el-col>
</template>

<script>
  import HotMapMarkerDialog from './HotMapMarkerDialog.vue'
  require('echarts/theme/macarons') // echarts theme
  import {
    debounce
  } from '../../utils/helper.js'
  import lodash from 'lodash'
  import fwUtil from 'framework-util'
  import VideoHls from '../images/VideoHls.vue'
  import {getDataService} from '../../api/chart/chart/index.js'
  import ImageOpenDialog from './ImageOpenDialog.vue'
  export default {
    components: {
      HotMapMarkerDialog,ImageOpenDialog
    },
    props: {
      className: {
        type: String,
        default: 'chart'
      },
      width: {
        type: Number,
        default: 24
      },
      height: {
        type: String,
        default: '100%'
      },
      autoResize: {
        type: Boolean,
        default: true
      },

      // clssifyConfig:{
      //   type:Array,
      //   default:function(){
      //     return []
      //   }
      // },
      queryConfig:{
        type:Object,
        default:function(){
          return {hotDataUrl:null,
          markerDataUrl:null,
          roadDataUrl:null,
          }
        }
      },
      // 图标配置
      chartConfig: {
        type: Object,
        default: function() {
          return {
            markerIcon:null,
            markerIconHeight:30,
            markerIconWidth:30,
            isHotMapMarket:'1',
            classifyConfig:[],//name,icon,type:'类型',url:加载的url地址,defaultLoad:'1' 是否默认加载,clickIcon:点击点的图标,如果没有，则使用markerIcon,isShow:'1'是否显示
            center: {
              lng: 116.404,
              lat: 39.915
            },
            zoom: 11
          }
        }
      },
      screen: {
        type: Object,
        default () {
          return {
            height: 1920,
            width: 1280,
          }
        }
      },
      page: {
        type: Object,
        default () {
          return {
            height: 1920,
            width: 1280,
          }
        }
      }
    },
    computed: {
      widthHeight() {
        return {
          width: this.width,
          height: this.height
        }
      },
      showClassify(){
        if(this.chartConfig && this.chartConfig.classifyConfig && this.chartConfig.classifyConfig.length>0){
          return true;
        }
        return false;
      },
      showRoadCard(){
        if(this.queryConfig.roadDataUrl){
          return true
        }
        return false
      }


    },
    data() {
      return {
        chart: null,
        currentShowType:'',
        currentMarker:{scenicName:'',realCount:'',addCount:''},
        sidebarElm: null,
        hasInitMap: false,
        heatmapOverlay: null,
        chartConfigModel: {},
        map:null,
        hotMapData:[],
        realData:[],
        roadData:[],
        chartWidth: '100%',
        chartHeight: '100%',
        timer:null,
        defaultConfig: {

          center: {
            lng: 116.404,
            lat: 39.915
          },
          zoom: 11
        }

      }
    },
    watch: {
      // 防止表格预置数据不成功，涉及生命周期问题
      chartConfig: {
        handler(newValue, oldValue) {
          this.chartConfigModel = lodash.cloneDeep(newValue)
          let _config = lodash.cloneDeep(this.defaultConfig)
          lodash.merge(_config, this.chartConfigModel)
          this.chartConfigModel = _config
          this.initBaiduMap()
          //this.setHotMap()
          this.getData()
        },
        deep: true
      },
      widthHeight: {
        handler(newValue, oldValue) {
          this.initBaiduMap()
         this.getData()
        },
        deep: true
      }
    },
    created() {

    },
    mounted() {
      this.chartConfigModel = lodash.cloneDeep(this.chartConfig)
      let _config = lodash.cloneDeep(this.defaultConfig)
      lodash.merge(_config, this.chartConfigModel)
      this.chartConfigModel = _config
      this.initBaiduMap()
      this.getData()
      this.timer=setInterval(function(){
        that.getData()
      },1000*60*5)
      //this.setHotMap()
    },
    beforeDestroy() {
      if(this.timer!=null){
        clearInterval(this.timer)
        this.timer=null
      }
    },
    methods: {
      getBtnColor(item){
        console.info("========state=="+item.state)
        if(item.state==1){
          return '#4fd17d'
        }else if(item.state==2){
          return '#ffd145'
        }else if(item.state==3){
          return '#e80c0c'
        }else if(item.state==4){
          return '#b50000'
        }else{
          return '#4fd17d'
        }
      },
      getSelectStyle(item) {
        if (item.code == this.currentShowType) {
          return "background: rgba(0, 177, 255, 0.3);border: 3px solid #00B1FF;"
        } else {
          return ""
        }
      },
      getData(){
         this.map.clearOverlays()

        if(this.queryConfig.hotDataUrl){
          getDataService(this.queryConfig.hotDataUrl,{}).then((res)=>{
            this.hotMapData=res
            this.setHotMap()
          })
        }
        if(this.queryConfig.markerDataUrl){
          this.setMarkerData()
        }
        if(this.queryConfig.roadDataUrl){
          this.getRoadData()
        }
        if(this.chartConfig && this.chartConfig.classifyConfig){
          for(let i=0;i<this.chartConfig.classifyConfig.length;i++){
            let _classifyConfig=this.chartConfig.classifyConfig[i]
            if(_classifyConfig["defaultLoad"]=='1'
            ){
              this.getClassifyData(_classifyConfig)
          }
        }
        }
      },
      changeClassify(item){
        this.currentShowType = item.code
        this.getClassifyData(item)
      },
      setClassifyMarker(_config,res){
        let that=this
       if(res){
         for(let i=0;i<res.length;i++){
           let icon=this.chartConfig.markerIcon
           if(_config["clickIcon"]){
             icon=_config["clickIcon"]
           }
           var myIcon = new BMap.Icon(icon, new BMap.Size(this.chartConfig.markerIconWidth, this.chartConfig.markerIconHeight),{imageSize:new BMap.Size(this.chartConfig.markerIconWidth, this.chartConfig.markerIconHeight)});
           // 创建Marker标注，使用小车图标
           var pt = new BMap.Point(res[i].lng, res[i].lat);
           var marker = new BMap.Marker(pt, {
               icon: myIcon
           });
           this.map.addOverlay(marker);
           let markerData=res[i]
           marker.addEventListener('click', function () {
               that.currentMarker=markerData
               
               if(that.chartConfig.isHotMapMarket!='1'){
                   that.$refs.markerDialog.show()
               }else{
                 that.$refs.imageMarkerDialog.show()
               }

           });
         }
       }
      },
      getClassifyData(_config){
         //this.map.clearOverlays();
         if(! _config["url"]){
            this.setClassifyMarker(_config,_config.list)
         }else{
           let that=this
           getDataService(_config["url"]).then((res)=>{
               that.setClassifyMarker(_config,res)
             })
         }

      },
      getRoadData(){
        let that=this
        if(!this.queryConfig.roadDataUrl){
          return
        }
        getDataService(this.queryConfig.roadDataUrl,{}).then((res)=>{
          this.roadData=res
        })
      },
      setMarkerData(){
        let that=this
        if(!this.queryConfig.markerDataUrl){
          return
        }
        getDataService(this.queryConfig.markerDataUrl,{}).then((res)=>{
          this.realData=res
          if(res){
            for(let i=0;i<res.length;i++){
              var myIcon = new BMap.Icon(this.chartConfig.markerIcon, new BMap.Size(this.chartConfig.markerIconWidth, this.chartConfig.markerIconHeight),{imageSize:new BMap.Size(this.chartConfig.markerIconWidth, this.chartConfig.markerIconHeight)});
              // 创建Marker标注，使用小车图标
              var pt = new BMap.Point(res[i].lng, res[i].lat);
              var marker = new BMap.Marker(pt, {
                  icon: myIcon
              });
              this.map.addOverlay(marker);
              let markerData=res[i]
              marker.addEventListener('click', function () {
                  that.currentMarker=markerData
                  if(that.chartConfig.isHotMapMarket!='1'){
                      that.$refs.markerDialog.show()
                  }else{
                    that.$refs.imageMarkerDialog.show()
                  }
              });
            }
          }
        })
      },
      initBaiduMap() {
        const _that = this
        this.map = new BMap.Map('baiduMap') // 创建Map实例
        this.map.centerAndZoom(new BMap.Point(this.chartConfigModel.center.lng, this.chartConfigModel.center.lat), this.chartConfigModel
          .zoom) // 创建点坐标,初始化地图,设置中心点坐标和地图级别
        this.map.addEventListener('zoomend', function(e) {
          var ZoomNum = _that.map.getZoom()
          console.info('===' + ZoomNum)
          _that.setHotMap()
        })
        _that.hasInitMap = true
        if(this.chartConfigModel.mapStyle){
          this.map.setMapStyleV2({
            styleJson: this.chartConfigModel.mapStyle
          })
        }
        if (this.chartConfigModel.canMove) {
          this.map.enableScrollWheelZoom(); // 允许滚轮缩放
        }
        if(this.showRoadCard){
            let traffic = new BMap.TrafficLayer();
            this.map.addTileLayer(traffic);
        }
        // }
      },
      setHotMap() {
        if(this.hotMapData && this.hotMapData.length>0){
          this.heatmapOverlay = new BMapLib.HeatmapOverlay({
            'radius': 70
          })
          this.map.addOverlay(this.heatmapOverlay)
          this.heatmapOverlay.setDataSet({
            data: this.hotMapData,
            max: 70
          })
          this.setHotRadius()
          this.heatmapOverlay.show()
          this.setGradient()
        }

      },
      setHotRadius() {
        console.info('=======' + this.map.getZoom())
        if (this.heatmapOverlay != null && this.heatmapOverlay != undefined) {
          var zoomDiff = this.map.getZoom() - this.zoom
          if (zoomDiff > 0) {
            this.heatmapOverlay.setOptions({
              'radius': 100 * Math.pow(1.2, zoomDiff),
              'opacity': 0
            })
            this.setGradient();
          } else if (zoomDiff < 0) {
            this.heatmapOverlay.setOptions({
              'radius': 100 * Math.pow(0.5, Math.abs(zoomDiff)),
              'opacity': 0
            })
            this.setGradient();
          } else {
            this.heatmapOverlay.setOptions({
              'radius': 100 * Math.pow(0.5, Math.abs(zoomDiff)),
              'opacity': 0
            })
            this.setGradient();
          }
        }
      },
      setGradient() {
        var gradient = {
          0.1: '#88B1E5',
          0.3: '#5CE2E0',
          0.5: '#50E672',
          0.7: '#E5DF63',
          0.9: '#EA7B39',
          1: '#E92435'
        }
        this.heatmapOverlay.setOptions({
          'gradient': gradient
        })
      },
      getLeftItemImageWidth() {
        let _height = this.chartConfig.leftItemHeight ? this.chartConfig.leftItemHeight : 40;
        let height = _height / this.page.height * this.screen.height
        return height / 2 + 'px'
      },
      getLeftMargin() {
        let _height = this.chartConfig.leftItemWidth ? this.chartConfig.leftItemWidth : 200;
        let height = _height / this.page.width * this.screen.width
        return height * 0.2 + 'px'
      },
      getLeftItemHeight() {
        let _height = this.chartConfig.leftItemHeight ? this.chartConfig.leftItemHeight : 40;
        let height = _height / this.page.height * this.screen.height
        return height + 'px'
      },
      getLeftItemWidth() {
        let _height = this.chartConfig.leftItemWidth ? this.chartConfig.leftItemWidth : 200;
        let height = _height / this.page.width * this.screen.width
        return height + 'px'
      }

    }
  }
</script>
<style>
  .BMap_cpyCtrl {
      display:none;
    }
    .anchorBL{
        display:none;
    }
</style>

<style scoped="scoped">
  .input-card {
      top: 1rem;
      right: auto;
      max-height: 90%;
      display: flex;
      flex-direction: column;
      min-width: 0;
      word-wrap: break-word;
      background-color: #fff;
      background-clip: border-box;
      border-radius: .25rem;
      width: 22rem;
      border-width: 0;
      border-radius: 0.4rem;
      box-shadow: 0 2px 6px 0 rgba(114, 124, 245, .5);
      position: absolute;
      bottom: 1rem;
      right: 1rem;
      -ms-flex: 1 1 auto;
      flex: 1 1 auto;
      padding: 0.75rem 1.25rem;
  }
  .btn{
        margin-left: 0;
        font-size: 14px;
        margin-top: 20px;
        font-family: inherit;
        font-size: inherit;
        line-height: inherit;
        overflow: visible;
        text-transform: none

  }

  .btn {
      display: inline-block;
      font-weight: 400;
      text-align: center;
      margin-top: 20px;
      vertical-align: middle;
      -webkit-user-select: none;
      -moz-user-select: none;
      user-select: none;
      -ms-user-select: none;
      border: 1px solid transparent;
      transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
      background-color: transparent;
      background-image: none;
      color: #38a800;
      border-color: #38a800;
      line-height: 1.5;
      border-radius: 1rem;
      -webkit-appearance: button;
      cursor: pointer;
  }
  .active{
      color: #fff;
      background-color: #25A5F7;
      border-color: #25A5F7
  }
  .btn:hover {
      color: #fff;
      background-color: #25A5F7;
      border-color: #25A5F7
  }

  .btn:hover {
      text-decoration: none
  }

  .btn:focus {
      outline: 0;
      box-shadow: none;
  }
</style>

<style >
  .customHotMap ::-webkit-scrollbar {
    width: 0;
  }
</style>

<style scoped="scoped">
  .leftMenu {
    background: url("data:image/png;base64,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");
    background-repeat: no-repeat;
    background-size: 100%100%;
    -webkit-background-size: 100%100%;
    -o-background-size: 100%100%;
    position: absolute;
    top: 40px;
    left: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .leftMenu .item {
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: left;
    width: 60%;
  }
</style>



// WEBPACK FOOTER //
// src/components/map/HotMapChart.vue